// Topbar notifications bell — per-screen i18n namespace (ar + en parity).
module.exports = {
  ar: {
    notifications: {
      title: 'الإشعارات',
      markAll: 'تحديد الكل كمقروء',
      loading: 'جاري التحميل…',
      error: 'تعذّر تحميل الإشعارات',
      empty: 'لا توجد إشعارات',
      unread: 'غير مقروء',
    },
  },
  en: {
    notifications: {
      title: 'Notifications',
      markAll: 'Mark all as read',
      loading: 'Loading…',
      error: 'Could not load notifications',
      empty: 'No notifications',
      unread: 'Unread',
    },
  },
};
